import { render, staticRenderFns } from "./FichaEmpresa.vue?vue&type=template&id=240e3c66&scoped=true&"
import script from "./FichaEmpresa.vue?vue&type=script&lang=js&"
export * from "./FichaEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./FichaEmpresa.vue?vue&type=style&index=0&id=240e3c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e3c66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRating,VRow,VSpacer})
